import React from "react";
import Header from "../components/portfolio/Header";
import Hero from "../components/portfolio/Hero";
import About from "../components/portfolio/About";
import Experience from "../components/portfolio/Experience";
import Projects from "../components/portfolio/Projects";
import Skills from "../components/portfolio/Skills";
import Contact from "../components/portfolio/Contact";
import Footer from "../components/portfolio/Footer";
import { Toaster } from "../components/ui/toaster";

const Portfolio = () => {
  return (
    <div className="min-h-screen bg-[#FAF7F2] text-[#1F1B16] antialiased selection:bg-[#1F1B16] selection:text-[#FAF7F2]">
      <Header />
      <main>
        <Hero />
        <About />
        <Experience />
        <Projects />
        <Skills />
        <Contact />
      </main>
      <Footer />
      <Toaster />
    </div>
  );
};

export default Portfolio;
